module.exports = __webpack_public_path__ + "img/AFMS_DREAR_OPEN.765c183d.png";